import { faStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalf"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Image,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { StyledArrowImage } from "areas/landing/elements/components"
import Slider from "dependencies/carousel"
import useWindowDimensions from "helpers/window-dimensions"

import { reviewsData } from "./data"

const StyledSlider = styled(Slider)`
  overflow: hidden;
`

const Card = styled(Box).attrs((props) => ({
  bg: "#f7f7f7",
  borderRadius: "16px",
  height: "100%",
  px: { _: 3, tablet: 4 },
  py: 4,
  ...props,
}))``

const ReadMoreReviews = styled(Button).attrs({
  bg: "blackPrint",
  color: "white",
  forwardedAs: Link,
})`
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  padding: 14px;
  width: 250px;
`

const CustomerReviews = ({ element }) => {
  const { isWidescreen, isDesktop, isMobile, isTablet } = useWindowDimensions()
  const sliderSettings = {
    autoplay: true,
    autoplayInterval: 4000,
    cellAlign: isTablet ? "center" : "left",
    cellSpacing: "12",
    defaultControlsConfig: {
      nextButtonText: (
        <StyledArrowImage
          alt="Next"
          height="54px"
          src={require("images/icons/arrow-dark-transparent.svg")}
          width="18px"
        />
      ),
      prevButtonText: (
        <StyledArrowImage
          alt="Previous"
          height="54px"
          src={require("images/icons/arrow-dark-transparent.svg")}
          width="18px"
        />
      ),
    },
    frameAriaLabel: "Customer reviews",
    slidesToShow: isWidescreen ? 3 : isDesktop ? 2 : isMobile ? 1.1 : 1.5,
    speed: 600,
    withoutControls: isTablet,
    wrapAround: true,
    ...element.slider_settings,
  }
  const ctaHeading = element.data?.cta?.heading || "Read More Reviews"
  const ctaUrl = element.data?.cta?.url || "/reviews"

  return (
    <Box
      px={{ desktop: 2 }}
      py={{ _: 3, tablet: 5 }}
      {...element.style?.block_style}
    >
      <Flex
        containWide
        flexDirection={{ _: "column", widescreen: "row" }}
        {...element.container_style}
      >
        <Flex
          alignItems="center"
          flex={{ widescreen: "0 0 406px" }}
          flexDirection="column"
          justifyContent="center"
          mb={{ _: "10px", widescreen: 0 }}
          mr={{ widescreen: 5 }}
          textAlign="center"
        >
          <Typography mb={2} variant="h2">
            Customers Love Us!
          </Typography>
          <a
            href="https://www.trustpilot.com/review/jewlr.com"
            rel="noreferrer"
            target="_blank"
          >
            <Image
              alt="Trustpilot"
              mb={2}
              ratio="1133 / 278"
              src={require("images/info/reviews/Trustpilot.svg")}
              width="246px"
            />
          </a>
          <Box mb="10px">
            <FontAwesomeIcon
              color="primary"
              fontSize="24px"
              icon={faStar}
              mr="4px"
            />
            <FontAwesomeIcon
              color="primary"
              fontSize="24px"
              icon={faStar}
              mr="4px"
            />
            <FontAwesomeIcon
              color="primary"
              fontSize="24px"
              icon={faStar}
              mr="4px"
            />
            <FontAwesomeIcon
              color="primary"
              fontSize="24px"
              icon={faStar}
              mr="4px"
            />
            <FontAwesomeIcon
              color="primary"
              fontSize="24px"
              icon={faStarHalf}
            />
          </Box>
          {/* <Typography fontWeight="600" variant="body-lg">
            50K+ 5-STAR REVIEWS
          </Typography> */}
          <ReadMoreReviews
            data-lc={element.anchor_name || element.id}
            display={{ _: "none", widescreen: "inline-block" }}
            mt={4}
            to={ctaUrl}
            {...element.style?.cta_style}
          >
            {ctaHeading}
          </ReadMoreReviews>
        </Flex>
        <StyledSlider {...sliderSettings}>
          {reviewsData.map((review, index) => (
            <Card key={`${element.id}-${index}`} {...element.style?.card_style}>
              <Typography fontWeight="600" mb="10px" variant="body-lg">
                {review.title}
              </Typography>
              <Typography variant="body">{review.text}</Typography>
              {review.recipient && (
                <>
                  <Typography
                    as="i"
                    display="inline-block"
                    fontSize="16px"
                    fontStyle="italic"
                    mt={2}
                    variant="body"
                  >
                    Recipient:
                  </Typography>
                  <Typography variant="body">{review.recipient}</Typography>
                </>
              )}
              {review.sender && (
                <Typography mt={2} variant="body">
                  &ndash; {review.sender}
                </Typography>
              )}
            </Card>
          ))}
        </StyledSlider>
      </Flex>
      <Box my={2} textAlign="center">
        <ReadMoreReviews
          data-lc={element.anchor_name || element.id}
          display={{ widescreen: "none" }}
          to={ctaUrl}
          {...element.style?.cta_style}
        >
          {ctaHeading}
        </ReadMoreReviews>
      </Box>
    </Box>
  )
}

CustomerReviews.propTypes = {
  element: PropTypes.object,
}

export default CustomerReviews
